import { inject, Injectable } from '@angular/core';
import { ActivitiesAggrigatorModel } from '@shared/model/activities-aggrigator-model';
import { ActivityVerbEnum } from '@shared/model/enum/activity-verb-enum';
import { ObjectTypeEnum } from '@shared/model/enum/object-type-enum';
import { INotifTextStrategy } from '../model/notification.model';
import { ActivityTextStrategy } from './activity-text-strategy';

@Injectable({
  providedIn: 'root'
})
export class LikeTextStrategy implements INotifTextStrategy {

  public createText(activity: ActivitiesAggrigatorModel, isAffectedContent = false): string {
    return this.composeLiketext(activity);
  }


  // ---------- Helpers ----------
  private composeLiketext(
    activity: ActivitiesAggrigatorModel): string {
    const objectType = activity?.inDirectObject?.objectType;
    const data = activity?.inDirectObject?.data;


    switch (objectType) {
      case ObjectTypeEnum.Review:
        return this.getReviewLikeText(data);

      case ObjectTypeEnum.Quote:
        return `بریدۀ کتاب منتشر کرد.`;

      case ObjectTypeEnum.Progress:
        return this.getProgressLikeText(activity);

      case ObjectTypeEnum.Post:
        return "پست منتشر کرد.";

      case ObjectTypeEnum.Booklist:
        return 'لیست منتشر کرد.';;

      case ObjectTypeEnum.Club:
        return `باشگاه ساخت.`;

      case ObjectTypeEnum.UserChallenge:
        return this.getUserChallengeLikeText(data);

      case ObjectTypeEnum.badge:
        return `مدال گرفت.`;

      case ObjectTypeEnum.UserReportPublished:
        return `گزارش سالیانه‌ی خود را منتشر کرد.`;

      default:
        return '';
    }
  }

  private getReviewLikeText(data: any): string {
    const hasBody = data?.body || data?.body?.length === 0;
    const hasRate = data?.Rate > 0;
    return !hasBody && hasRate ? 'امتیاز داد.' : 'یادداشت نوشت.';
  }

  private getProgressLikeText(activity: ActivitiesAggrigatorModel): string {
    const steps = activity.inDirectObject?.data?.steps;
    const totalPages = activity?.inDirectObject?.data?.totalPages;

    if (steps === -1) {
      return `می‌خواهد بخواند.`;
    }

    if (steps === totalPages) {
      return 'کتاب را تمام کرد.';
    }

    if (steps > 0 && steps !== totalPages) {
      return `تا صفحۀ ${steps} خواند.`;;
    }

    return 'شروع به مطالعه کرد.';
  }

  private getUserChallengeLikeText(data: any): string {
    const isCompleted = data?.totalStep === data?.currentStep;
    return isCompleted ? `چالش را تمام کرد.` : `به چالش پیوست.`;

  }
}

